import { render } from "./Register.vue?vue&type=template&id=20302aba&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=20302aba&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20302aba"]])

export default __exports__